const GRID_SIZE = 5;
const CELL_SIZE = 60;

export { GRID_SIZE, CELL_SIZE };